export default __webpack_public_path__ + "static/media/splashBackround.9644eb32.svg";